/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import styled from 'styled-components';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import { COLORS, FONT_WEIGHTS, FONT_FAMILIES } from 'shared/constants/theme';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import BaseLink from 'shared/components/presentational/CustomLink/CustomLink';
import {
  Modal,
  ModalBody,
  ButtonsWrapper
} from 'shared/blocks/selfcare/subscription-tunnel/shared/styles/components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  background-color: ${COLORS.concrete};
  padding: 40px;
  min-height: 80vh;
  ${mediaQueries.toPhone`
   padding: 20px;
  `};
`;

export const Title = styled.h1`
  margin: 22px 0 7px;
  text-transform: uppercase;
font-family: 
  font-size: ${pxInRem(30)};
  text-align: center;
  color: ${COLORS.black};
  font-style: ${FONT_WEIGHTS.bold};
  font-family: ${FONT_FAMILIES.new};

`;

export const Subtitle = styled.span`
  display: block;
  margin-bottom: 8px;
  font-size: ${pxInRem(18)};
  line-height: ${pxInRem(19)};
  text-align: center;
  color: ${COLORS.black};
  ${mediaQueries.toPhone`
    margin: 0 0 8px 0;
    font-size: ${pxInRem(16)};
  `}
`;

export const InformationsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 26px;
`;

export const Informations = styled.div`
  font-size: ${pxInRem(14)};
  color: ${COLORS.black};
  line-height: ${pxInRem(24)};
`;

export const InformationsIcon = styled.img`
  object-fit: contain;
  width: 24px;
  height: 24px;
  margin-right: 9px;
`;

export const Methods = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 490px;
  ${mediaQueries.toPhone`
    width: 100%;
  `}
`;

export const MethodWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const MethodTitle = styled.h3`
  margin: 40px 0 9px 0;
  font-weight: ${FONT_WEIGHTS.bold};
  font-family: ${FONT_FAMILIES.new};
  font-size: ${pxInRem(24)};
  text-align: center;
  text-transform: uppercase;
  color: ${COLORS.black};
  ${mediaQueries.toPhone`
    font-size: ${pxInRem(18)};
    margin: 32px 0 16px 0;
  `}
`;

export const MethodInformations = styled.div<{
  backgroundColor: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor ?? 'rgba(0, 0, 0, 0.06)'};
  width: 100%;
  padding: 12px;
  border-radius: var(--border-radius-m);
  margin-bottom: 16px;
`;

export const MethodLabel = styled.div<{
  color: string;
}>`
  color: ${props => props.color};
  font-size: ${pxInRem(14)};
  line-height: ${pxInRem(24)};
`;

export const Operators = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const OperatorLink = styled(BaseLink)`
  width: 100%;
`;
export const PhoneLink = styled.a`
  width: 100%;
`;

export const OperatorContainer = styled.div<{ inactive: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  width: 100%;
  padding: 5px 21px 5px 5px;
  cursor: ${props => (props.inactive ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.inactive ? 0.2 : 1)};
  margin-bottom: 16px;
`;

export const OperatorInformations = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OperatorImage = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 16px;
  border-radius: var(--border-radius-m);
`;

export const OperatorLabel = styled.span`
  font-size: ${pxInRem(16)};
`;

export const CurrencyModal = styled(Modal)`
  width: 100%;

  & ${ModalBody} {
    padding: 0;
  }

  // override default behavior of ButtonsWrapper on mobile (which is sticky)
  & ${ButtonsWrapper} {
    padding: 24px;
    position: static;
    width: 100%;
    box-shadow: none;
  }
`;
